import { createContext, useContext } from "react"

/**
 * True for content rendered inside the universal dialog. Forms use it to skip
 * their own safe-area bottom spacing, because the dialog already supplies it —
 * applying both left dialog forms sitting lower than hand-built ones.
 */
export const UniversalDialogContext = createContext(false)

export const useInsideUniversalDialog = () => useContext(UniversalDialogContext)
